import _defineProperty from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { deepMix, throttle } from '@antv/util';
import { subObject } from '../utils/helper';
import { useState, setCursor, restoreCursor } from './utils';
export var CATEGORY_LEGEND_CLASS_NAME = 'legend-category';
export var CONTINUOUS_LEGEND_CLASS_NAME = 'legend-continuous';
export var LEGEND_ITEMS_CLASS_NAME = 'items-item';
export var LEGEND_MAKER_CLASS_NAME = 'legend-category-item-marker';
export var LEGEND_LABEL_CLASS_NAME = 'legend-category-item-label';
export function markerOf(item) {
  return item.getElementsByClassName(LEGEND_MAKER_CLASS_NAME)[0];
}
export function labelOf(item) {
  return item.getElementsByClassName(LEGEND_LABEL_CLASS_NAME)[0];
}
export function itemsOf(root) {
  return root.getElementsByClassName(LEGEND_ITEMS_CLASS_NAME);
}
export function legendsOf(root) {
  return root.getElementsByClassName(CATEGORY_LEGEND_CLASS_NAME);
}
export function legendsContinuousOf(root) {
  return root.getElementsByClassName(CONTINUOUS_LEGEND_CLASS_NAME);
}
export function dataOf(root) {
  // legend -> layout -> container
  var parent = root.parentNode;
  while (parent && !parent.__data__) {
    parent = parent.parentNode;
  }
  return parent.__data__;
}
export function attributesOf(root) {
  var child = root;
  while (child && !child.attr('class').startsWith('legend')) {
    child = child.children[0];
  }
  return child.attributes;
}
function legendFilterOrdinal(root, _ref) {
  var _this = this;
  var legends = _ref.legends,
    markerOf = _ref.marker,
    labelOf = _ref.label,
    datum = _ref.datum,
    filter = _ref.filter,
    emitter = _ref.emitter,
    channel = _ref.channel,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? {} : _ref$state;
  // Index handler by item.
  var itemClick = new Map();
  var itemPointerenter = new Map();
  var itemPointerout = new Map();
  var _state$unselected = state.unselected,
    unselected = _state$unselected === void 0 ? {
      markerStroke: '#aaa',
      markerFill: '#aaa',
      labelFill: '#aaa'
    } : _state$unselected;
  var markerStyle = {
    unselected: subObject(unselected, 'marker')
  };
  var labelStyle = {
    unselected: subObject(unselected, 'label')
  };
  var _useState = useState(markerStyle, undefined),
    setM = _useState.setState,
    removeM = _useState.removeState;
  var _useState2 = useState(labelStyle, undefined),
    setL = _useState2.setState,
    removeL = _useState2.removeState;
  var items = Array.from(legends(root));
  var selectedValues = items.map(datum);
  var updateLegendState = function updateLegendState() {
    for (var _i = 0, _items = items; _i < _items.length; _i++) {
      var item = _items[_i];
      var value = datum(item);
      var marker = markerOf(item);
      var label = labelOf(item);
      if (!selectedValues.includes(value)) {
        setM(marker, 'unselected');
        setL(label, 'unselected');
      } else {
        removeM(marker, 'unselected');
        removeL(label, 'unselected');
      }
    }
  };
  var _loop = function _loop() {
    var item = _items2[_i2];
    // Defined handlers.
    var pointerenter = function pointerenter() {
      setCursor(root, 'pointer');
    };
    var pointerout = function pointerout() {
      restoreCursor(root);
    };
    var click = function click(event) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
        var _selectedValues;
        var value, index, _event$nativeEvent, nativeEvent;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              value = datum(item);
              index = selectedValues.indexOf(value);
              if (index === -1) selectedValues.push(value);else selectedValues.splice(index, 1);
              if (selectedValues.length === 0) (_selectedValues = selectedValues).push.apply(_selectedValues, _toConsumableArray(items.map(datum)));
              _context.n = 1;
              return filter(selectedValues);
            case 1:
              updateLegendState();
              _event$nativeEvent = event.nativeEvent, nativeEvent = _event$nativeEvent === void 0 ? true : _event$nativeEvent;
              if (nativeEvent) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              if (selectedValues.length === items.length) {
                emitter.emit('legend:reset', {
                  nativeEvent: nativeEvent
                });
              } else {
                // Emit events.
                emitter.emit('legend:filter', Object.assign(Object.assign({}, event), {
                  nativeEvent: nativeEvent,
                  data: {
                    channel: channel,
                    values: selectedValues
                  }
                }));
              }
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
    };
    // Bind and store handlers.
    item.addEventListener('click', click);
    item.addEventListener('pointerenter', pointerenter);
    item.addEventListener('pointerout', pointerout);
    itemClick.set(item, click);
    itemPointerenter.set(item, pointerenter);
    itemPointerout.set(item, pointerout);
  };
  for (var _i2 = 0, _items2 = items; _i2 < _items2.length; _i2++) {
    _loop();
  }
  var onFilter = function onFilter(event) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee2() {
      var nativeEvent, data, specifiedChannel, values;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            nativeEvent = event.nativeEvent;
            if (!nativeEvent) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            data = event.data;
            specifiedChannel = data.channel, values = data.values;
            if (!(specifiedChannel !== channel)) {
              _context2.n = 2;
              break;
            }
            return _context2.a(2);
          case 2:
            selectedValues = values;
            _context2.n = 3;
            return filter(selectedValues);
          case 3:
            updateLegendState();
          case 4:
            return _context2.a(2);
        }
      }, _callee2);
    }));
  };
  var onEnd = function onEnd(event) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee3() {
      var nativeEvent;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            nativeEvent = event.nativeEvent;
            if (!nativeEvent) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2);
          case 1:
            selectedValues = items.map(datum);
            _context3.n = 2;
            return filter(selectedValues);
          case 2:
            updateLegendState();
          case 3:
            return _context3.a(2);
        }
      }, _callee3);
    }));
  };
  emitter.on('legend:filter', onFilter);
  emitter.on('legend:reset', onEnd);
  return function () {
    for (var _i3 = 0, _items3 = items; _i3 < _items3.length; _i3++) {
      var item = _items3[_i3];
      item.removeEventListener('click', itemClick.get(item));
      item.removeEventListener('pointerenter', itemPointerenter.get(item));
      item.removeEventListener('pointerout', itemPointerout.get(item));
      emitter.off('legend:filter', onFilter);
      emitter.off('legend:reset', onEnd);
    }
  };
}
function legendFilterContinuous(_, _ref2) {
  var legend = _ref2.legend,
    filter = _ref2.filter,
    emitter = _ref2.emitter,
    channel = _ref2.channel;
  var onValueChange = function onValueChange(_ref3) {
    var value = _ref3.detail.value;
    filter(value);
    emitter.emit({
      nativeEvent: true,
      data: {
        channel: channel,
        values: value
      }
    });
  };
  legend.addEventListener('valuechange', onValueChange);
  return function () {
    legend.removeEventListener('valuechange', onValueChange);
  };
}
export function LegendFilter() {
  var _this2 = this;
  return function (context, _, emitter) {
    var container = context.container,
      view = context.view,
      update = context.update,
      setState = context.setState;
    var channelsOf = function channelsOf(legend) {
      return dataOf(legend).scales.map(function (d) {
        return d.name;
      });
    };
    var legends = [].concat(_toConsumableArray(legendsOf(container)), _toConsumableArray(legendsContinuousOf(container)));
    var allChannels = legends.flatMap(channelsOf);
    var _filter = throttle(function (legend, channel, value, ordinal, channels) {
      return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              setState(legend, function (viewOptions) {
                var marks = viewOptions.marks; // Add filter transform for every marks,
                // which will skip for mark without color channel.
                var newMarks = marks.map(function (mark) {
                  if (mark.type === 'legends') return mark;
                  // Inset after aggregate transform, such as group, and bin.
                  var _mark$transform = mark.transform,
                    transform = _mark$transform === void 0 ? [] : _mark$transform;
                  var index = transform.findIndex(function (_ref4) {
                    var type = _ref4.type;
                    return type.startsWith('group') || type.startsWith('bin');
                  });
                  var newTransform = _toConsumableArray(transform);
                  newTransform.splice(index + 1, 0, _defineProperty({
                    type: 'filter'
                  }, channel, {
                    value: value,
                    ordinal: ordinal
                  }));
                  // Set domain of scale to preserve encoding.
                  var newScale = Object.fromEntries(channels.map(function (channel) {
                    return [channel, {
                      domain: view.scale[channel].getOptions().domain
                    }];
                  }));
                  return deepMix({}, mark, Object.assign(Object.assign({
                    transform: newTransform,
                    scale: newScale
                  }, !ordinal && {
                    animate: false
                  }), {
                    legend: Object.fromEntries(allChannels.map(function (d) {
                      return [d, {
                        preserve: true
                      }];
                    }))
                  }));
                });
                return Object.assign(Object.assign({}, viewOptions), {
                  marks: newMarks
                });
              });
              _context4.n = 1;
              return update();
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }));
    }, 50, {
      trailing: true
    });
    var removes = legends.map(function (legend) {
      var _dataOf$scales$ = dataOf(legend).scales[0],
        channel = _dataOf$scales$.name,
        domain = _dataOf$scales$.domain;
      var channels = channelsOf(legend);
      if (legend.className === CATEGORY_LEGEND_CLASS_NAME) {
        return legendFilterOrdinal(container, {
          legends: itemsOf,
          marker: markerOf,
          label: labelOf,
          datum: function datum(d) {
            var datum = d.__data__;
            var index = datum.index;
            return domain[index];
          },
          filter: function filter(value) {
            return _filter(legend, channel, value, true, channels);
          },
          state: legend.attributes.state,
          channel: channel,
          emitter: emitter
        });
      } else {
        return legendFilterContinuous(container, {
          legend: legend,
          filter: function filter(value) {
            return _filter(legend, channel, value, false, channels);
          },
          emitter: emitter,
          channel: channel
        });
      }
    });
    return function () {
      removes.forEach(function (remove) {
        return remove();
      });
    };
  };
}